import "vue";
const b = Symbol("TabsProvide"), e = Symbol("TabsKey");
export {
  e as TabsKey,
  b as TabsProvideKey
};
